import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MoldRevisionItem } from '../models/item';
import { FormControl } from '@angular/forms';

@Injectable()
export class MoldContainerService<Type extends MoldRevisionItem> {
  private _formFilter = new FormControl<string>(undefined);
  get formFilter(): FormControl<string> {
    return this._formFilter;
  }

  private _machines = new BehaviorSubject<Type['mold']['machines']>([]);
  machines$ = this._machines.asObservable();
  set machines(value: Type['mold']['machines']) {
    this._machines.next(value);
  }

  globalFilter$ = this._formFilter.valueChanges.pipe(startWith(''));

  private _moldList = new BehaviorSubject<Type[]>([]);
  listComplete$ = this._moldList.asObservable();
  set moldList(value: Type[]) {
    this._moldList.next(value);
  }

  activeList$: Observable<Type[]> = combineLatest([
    this._moldList,
    this.globalFilter$,
  ]).pipe(
    map(([molds, filter]) =>
      molds.filter((el) => el.active && this.filterMold(el, filter))
    )
  );

  inactiveList$: Observable<Type[]> = combineLatest([
    this._moldList,
    this.globalFilter$,
  ]).pipe(
    map(([molds, filter]) =>
      molds.filter((el) => !el.active && this.filterMold(el, filter))
    )
  );

  molds$: Observable<Type['mold'][]> = this.listComplete$.pipe(
    map((molds) =>
      molds
        .map((el) => el.mold)
        .reduce(
          (acc, val) =>
            acc.find((el) => el.id === val.id) ? acc : [...acc, val],
          []
        )
    )
  );

  constructor() {}

  newMoldRevision(item: Type): void {
    this.moldList = [...this._moldList.value, item];
  }

  filterMold(item: Type, filter: string): boolean {
    return item.title.toLowerCase().includes(filter.toLowerCase());
  }
  replaceItem(item: Type): void {
    this.moldList = this._moldList.value.map((el) =>
      el.id === item.id ? item : el
    );
  }
}
